import {
  ADD_GPT_MSG,
  ADD_GPT_MSG_SUCCESS,
  ADD_GPT_MSG_FAILURE,
  GET_GPT_MSG,
  GET_GPT_MSG_SUCCESS,
  GET_GPT_MSG_FAILURE,
} from "../constants";

export default class GptMessageAction {
  static addGptMessage(payload, cb) {
    return {
      type: ADD_GPT_MSG,
      payload,
      cb,
    };
  }
  static addGptMessageSuccess(payload) {
    return {
      type: ADD_GPT_MSG_SUCCESS,
      payload,
    };
  }
  static addGptMessageFailure(payload) {
    return {
      type: ADD_GPT_MSG_FAILURE,
      payload,
    };
  }
  static getGptMessage(cb) {
    return {
      type: GET_GPT_MSG,
      cb,
    };
  }
  static getGptMessageSuccess(payload) {
    return {
      type: GET_GPT_MSG_SUCCESS,
      payload,
    };
  }
  static getGptMessageFailure(payload) {
    return {
      type: GET_GPT_MSG_FAILURE,
      payload,
    };
  }
}
